import Header from 'components/_OldDesign/header'
import React, { ReactElement, useEffect, useState } from 'react'
import style from 'styles/Content.module.scss'
import cultureStyle from 'styles/culture.module.scss'
import { GetStaticProps } from 'next';
import 'react-multi-carousel/lib/styles.css';
import { be, strapi, } from 'models/conent';
import { filterContent, findContentByTitle, translate } from 'utils/translate';
import { useRouter } from 'next/router';
import ProductHeader from 'components/_OldDesign/productHeader';
import Content from 'components/_OldDesign/content';
import ReuseForms from 'components/_OldDesign/forms';
import fetchStrapi from 'lib/fetchStrapi';
import { NextPageWithLayout } from './_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';

export const getStaticProps: GetStaticProps = async () => {
    try {
        const contents = await fetchStrapi('/services');
        return {
            props: {
                contents,
            },
        };
    } catch (error) {
        // // console.log(error);
        return {
            props: {
                data: JSON.stringify(error),
            },
        };
    }
}

const ESignature: NextPageWithLayout<{contents:any}> = ({ contents }) => {
    const router = useRouter();
    const {lang, setLang} = useLocale();

    useEffect(() => {
        const defaultLocale = (localStorage.getItem('lang') ?? 'th') as Lang;
        setLang(defaultLocale);
    }, []);


    const findContent = (item, name) => {
        if (!item) return;
        return item.find(item => item.name === name || item.title === name)
    }
    return <div className="w-screen">
        <Header content={{ content: 'ซอฟต์แวร์และเทคโนโลยีที่ทันสมัย เพื่อผู้ใช้งานจริง โดยผู้เชี่ยวชาญด้านนวัตกรรมเฉพาะ', title: 'ซอฟต์แวร์และเทคโนโลยีที่ทันสมัย เพื่อผู้ใช้งานจริง โดยผู้เชี่ยวชาญด้านนวัตกรรมเฉพาะ', image: null }} />
        {<ProductHeader headerItem={findContent(contents, 'Intro')} />}
        {/* Intro */}
        <div className="px-8 xl:px-0  mt-16">
            {/* <div className={`relative mb-16`}>
                <img src={`${be}${content?.image[0].url}`} className="z-10 w-full h-1/2 xl:h-screen xl:w-screen xl:m-auto" alt="e-signature" />
                <p className={`absolute tracking-tight flex flex-col text-white mb-10 ${cultureStyle.service} `}>
                    <span className="text-4xl mb-24 z-20" >{content?.title}</span>
                </p>
            </div> */}

            {/* card */}
            <div >
                {filterContent(contents, 'card')?.sort((a, b) => a.id - b.id).map((item, i) =>
                    <div key={i} className={`relative ${style.firstTitle}  p-8 mt-32 border-2 rounded-2xl xl:m-16 lg:p-16 xl:hidden ${cultureStyle.borderBlue2}`}>
                        <img src={`${be}${item?.image[0].url}`} className={`${cultureStyle.circle}  absolute right-4 -top-28 xl:h-60`} alt="CODIUM" loading="lazy"/>
                        <h1 className="font-normal text-4xl md:text-2xl text-center mt-8">{translate(item, 'title', lang)}</h1>
                        <h1 className="text-3xl md:text-xl mt-16 md:mt-8 font-light text-center">{translate(item, 'description', lang)}</h1>
                        {item.subContent ? <>
                            {item.subContent.map((sub, subId) =>
                                <>
                                    <div key={subId} data-aos="zoom-in" data-aos-delay="500">
                                        <div className="grid grid-cols-3">
                                            <div></div>
                                            <h1 className="font-normal text-4xl md:text-2xl text-left mt-8 col-span-2 xl:text-base">{translate(sub, 'title', lang)}</h1></div>
                                        <div className="grid grid-cols-3">
                                            <img src={`${be}${sub?.image[0].url}`} className="m-auto xl:h-60 xl:text-xs" alt="CODIUM" loading="lazy"/>
                                            <p className="text-3xl md:text-xl mt-16 md:mt-8 font-light text-left col-span-2">{translate(sub, 'description', lang)}</p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                            : ''}
                    </div>)}
                <div className="hidden grid-cols-3 xl:grid xl:px-48">
                    <div className="col-span-2">
                        <div className={`relative ${style.firstTitle} m-4 border-2 rounded-2xl p-4 ${cultureStyle.borderBlue2}`} >
                            <img src={`${be}${findContentByTitle(contents, 'Mobile Application')?.image[0].url}`} className={`${cultureStyle.circle}  absolute -right-4 -top-20 h-24 xl:h-16`} style={{ height: '10rem' }} alt="Mobile Application" loading="lazy"/>
                            <h1 className="font-normal text-2xl text-center mt-8">{translate(findContentByTitle(contents, 'Mobile Application'), 'title', lang)}</h1>
                            <h1 className={`text-base xl:text-xs px-2  mt-16 md:mt-8 xl:my-4 font-light text-center ${lang === 'th' ? 'thai-lh' : ''}`}>
                                {translate(findContentByTitle(contents, 'Mobile Application'), 'description', lang)}
                            </h1>
                            {findContentByTitle(contents, 'Mobile Application')?.subContent ? <>
                                <div className="grid grid-cols-3">
                                    {findContentByTitle(contents, 'Mobile Application')?.subContent.map((sub, subId) =>
                                        <div key={subId} data-aos="zoom-in" data-aos-delay="500">
                                            <div>
                                                <img src={`${be}${sub?.image[0].url}`} className="m-auto my-4 xl:h-16" alt="Mobile Application" loading="lazy"/>
                                                <h1 className="font-normal text-4xl md:text-2xl text-center my-4 col-span-2 xl:text-base">
                                                    {translate(sub, 'title', lang)}
                                                </h1>
                                                <p className={`text-base xl:text-xs mt-16 xl:mt-0 px-4 font-light text-left col-span-2 ${ lang==='th' ? 'thai-lh' : ''}`}>
                                                    {translate(sub, 'description', lang)}
                                                </p>
                                            </div>
                                        </div>)}
                                </div>
                            </> : ''}
                        </div>
                    </div>

                    {/* Desktop */}
                    <div >
                        {contents?.filter((item) => item.title.includes('Desktop Application') || item.title.includes('Web Application')).map((item, i) =>
                            <div key={i} className={`relative ${style.firstTitle} m-4 mb-8 border-2 rounded-2xl p-4 hidden xl:block ${cultureStyle.borderBlue2}`}>
                                <img src={`${be}${item?.image[0].url}`} className={`${cultureStyle.circle} absolute -right-4 -top-20 h-24`} style={{ height: '10rem' }} alt="Desktop Application" loading="lazy"/>
                                <h1 className="font-normal text-2xl text-center mt-8">{translate(item, 'title', lang)}</h1>
                                <h1 className={`text-base xl:text-xs mt-16  xl:mt-4 font-light text-center ${lang === 'th' ? 'thai-lh' : ''}`}>
                                    {translate(item, 'description', lang)}
                                </h1>
                                {item.subContent ? <>
                                    {item.subContent.map((sub, subId) => <div key={subId} className="grid col-span-2">
                                        <div>
                                            <div className="grid grid-cols-3">
                                                <div></div>
                                                <h1 className="font-normal text-4xl text-left mt-8 col-span-2 xl:text-base">{translate(sub, 'title', lang)}</h1></div>
                                            <div className="grid grid-cols-3">
                                                <img src={`${be}${sub?.image[0].url}`} className="my-auto mr-auto xl:h-32 xl:text-xs" alt="Desktop Application" loading="lazy"/>
                                                <p className="text-base xl:text-xs  mt-16  xl:mt-4 font-light text-left col-span-2">{translate(sub, 'description', lang)}</p>
                                            </div>
                                        </div>
                                    </div>)}
                                </> : ''}
                            </div>)}
                    </div>
                </div>

                {/* Mobile */}

                <div className="grid grid-cols-2 my-12 mt-6 xl:mt-0 xl:px-48">
                    {contents?.filter((item) => item.title.includes('Artificial Intelligence') || item.title.includes('Tech Consultant')).map((item, i) =>
                        <div key={i} className={`relative ${style.firstTitle}  m-4 border-2 rounded-2xl   p-4 hidden xl:block ${cultureStyle.borderBlue2}`}>
                            <img src={`${be}${item.image[0]?.url}`} className={`${cultureStyle.circle} absolute -right-4 -top-20 h-24`} style={{ height: '10rem' }} alt="Artificial Intelligence" loading="lazy"/>
                            <h1 className="font-normal text-2xl text-center mt-8">{translate(item, 'title', lang)}</h1>
                            <h1 className={`text-base xl:text-xs mt-16  xl:mt-4 font-light text-center ${lang === 'th' ? 'thai-lh' : ''}`}>
                                {translate(item, 'description', lang)}
                            </h1>
                            {item.subContent ? <>
                                {item.subContent.map((sub, subId) => <div key={subId} className="grid col-span-2">
                                    <div>
                                        <div className="grid grid-cols-3">
                                            <div></div>
                                            <h1 className="font-normal text-4xl md:text-2xl text-left mt-8 col-span-2 xl:text-base">{translate(sub, 'title', lang)}</h1></div>
                                        <div className="grid grid-cols-3">
                                            <img src={`${be}${sub.image[0]?.url}`} className="my-auto mr-auto xl:h-24 xl:text-xs" loading="lazy"/>
                                            <p className="text-base xl:text-xs mt-16  xl:mt-4 font-light text-left col-span-2">{translate(sub, 'description', lang)}</p>
                                        </div>
                                    </div>
                                </div>)}
                            </> : ''}
                        </div>)}
                </div>
            </div>

            {/* STACK */}

            <Content contents={contents?.find(item => item.name === 'OUR TECHNOLOGY STACK')} padding={false} />
            {/* forms */}

            <ReuseForms form={findContent(contents, 'Forms')} product={'PROJECT'} event={'serviceFormSubmit'} />
        </div>
    </div>

}

ESignature.getLayout = (page: ReactElement) => {
    return <OldLayout>{page}</OldLayout>;
};

export default ESignature;
